import DOMPurify from 'dompurify';
import { Box, Typography } from '@mui/material';
import { PageTransitionWrapper, ResponsiveBreak } from 'src/components';

import { hiFiveImgURL } from 'src/constants/apiEndpoints/awsS3';

export const ReferralBenefits: React.FC<{
  data: string[] | null;
}> = ({ data }) => {
  if (!data) return null;

  return (
    <PageTransitionWrapper
      display="flex"
      flexDirection="column"
      gap={3}
      width="100%"
    >
      <Typography variant="h1" textAlign="start">
        Get nice cash bonuses
        <ResponsiveBreak breakpoint="sm" /> for bringing your friends
        to AgileEngine
      </Typography>
      <Box
        display="flex"
        justifyContent="start"
        alignItems="center"
        flexDirection={{ xs: 'column', md: 'row' }}
        sx={{
          background: '#FFF',
          borderRadius: '16px',
          padding: '24px 16px',
        }}
      >
        <Box
          component="img"
          src={hiFiveImgURL}
          alt="hi five"
          sx={{
            width: { xs: '120px', md: '147px' },
            height: { xs: '120px', md: '147px' },
          }}
        />
        <Box component="ul" sx={{ pl: { xs: 3, md: 5 }, my: 0 }}>
          {data.map((benefit) => (
            <Box key={benefit} component="li">
              <Typography
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(benefit, {
                    ALLOWED_TAGS: ['b'],
                    ALLOWED_ATTR: [],
                  }),
                }}
              ></Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </PageTransitionWrapper>
  );
};
